import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import {
  IUserInfoRequest,
  IUserLoginRequest,
  IUserRegisterRequest,
  ILikeRequest,
  IGoogleLogin,
  IUserEditRequest,
  IUserOTPLoginRequest,
  IUserDetailResponse,
  IResetPasswordRequest,
  IVerifyEmailRequest,
} from "./user.type";

export default {
  async checkIsRegistered(data: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/is_register", data, {});
  },
  async register(data: IUserRegisterRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/register", data, {});
  },
  async login(data: IUserLoginRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/login", data, {});
  },
  async OTPlogin(data: IUserOTPLoginRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/otp", data, {});
  },
  async magicLogin(data: { token: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/magic-login", data, {});
  },
  async magicLoginRequest(data: { email: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/magic-login/request", data, {});
  },
  // STRIPE P5-F6 (v3 P5-B8): verification links expire; this mails a fresh one to a pending signup. Always the same 200
  // (enumeration-safe), 429 when rate-limited.
  async resendVerification(data: { email: string }): Promise<ApiResponse<{ message?: string }>> {
    return await RefabricProURL.post("users/resend_verification", data, {});
  },
  // REF-5421: forced post-magic-login password creation for a passwordless guest.
  // No current_password — auth is the magic-minted (gated) token. Success returns a
  // fresh claim-less token in responseData.token that the caller MUST swap in.
  async setPassword(data: { password: string; password_replay: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/set-password", data, {});
  },
  async getUserDetail(params: IUserInfoRequest): Promise<ApiResponse<IUserDetailResponse>> {
    return await RefabricProURL.get(`users/${params.user_id}`, {});
  },
  async tokenControl(data: { client_id: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/token_control", data, {});
  },
  async like(data: ILikeRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/favorites", data, {});
  },
  async getFavorites(params: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`users/favorites/${params.object_type}`, {});
  },
  async forgotPassword(data: { email: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`users/forgot_password`, data, {});
  },
  // P4-F4: one-time tokens travel in the BODY — in the path they were written by every request log on the way in.
  async resetPassword(data: IResetPasswordRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/reset_password", data, {});
  },
  async verifyEmail(data: IVerifyEmailRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/verify_email", data, {});
  },
  async refreshToken(data: { email: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`users/refresh_token`, data, {});
  },
  // Background session renewal (hooks/useSessionRefresh): bypasses the interceptor's logout / snackbar /
  // paywall UX, so EVERY non-2xx rejects — including 401/403/402/503 — and the caller handles it.
  async refreshTokenInBackground(data: { email: string }): Promise<ApiResponse<{ token?: string }>> {
    return await RefabricProURL.post(`users/refresh_token`, data, { skipGlobalErrorHandling: true });
  },
  async changePassword(user_id: string, data: { email: string; current_password: string; password: string; password_replay: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.put(`users/${user_id}/change_password`, data, {});
  },
  async googleLogin(data: IGoogleLogin): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("users/google_login", data, {});
  },
  async editUserDetail(user_id: string, data: IUserEditRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.put(`users/${user_id}`, data, {});
  },
  async getInvoiceList(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`users/invoice_list`, {});
  },
  async updateForcePackage(userId: string, data: { is_accepted: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.put(`users/${userId}/update_force_package`, data, {});
  },
};
